import React from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';
import ga from 'react-ga';

const Intro = props => (
  <div className={props.className}>
    <div>
      Also check
      <Icon type="smile-o" style={{ marginLeft: '15px' }} />
    </div>
    <div className="icons">
      <ga.OutboundLink
        eventLabel="https://medium.com/@ShizukuIchi"
        to="https://medium.com/@ShizukuIchi"
        target="_blank"
      >
        <Icon
          style={{
            color: getColor(props.dayTime),
            transition: 'color 1s',
            transform: 'scale(1.2)',
          }}
          type="medium"
        />
      </ga.OutboundLink>
      <ga.OutboundLink
        eventLabel="https://github.com/ShizukuIchi"
        to="https://github.com/ShizukuIchi"
        target="_blank"
      >
        <Icon
          style={{
            color: getColor(props.dayTime),
            transition: 'color 1s',
          }}
          type="github"
        />
      </ga.OutboundLink>
      <ga.OutboundLink
        eventLabel="https://sh1zuku.csie.io/blog"
        to="https://sh1zuku.csie.io/blog"
        target="_blank"
      >
        <Icon
          style={{
            color: getColor(props.dayTime),
            transition: 'color 1s',
          }}
          type="book"
          theme="filled"
        />
      </ga.OutboundLink>
    </div>
  </div>
);
function getColor(dayTime) {
  return dayTime === 'day' ? 'rgb(60, 60, 60)' : 'rgb(240,240,240)';
}
export default styled(Intro)`
  font-size: 1.8em;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ dayTime }) => getColor(dayTime)};
  transition: color 1s;
  & > * {
    position: relative;
  }
  .icons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  a {
    transition: transform 0.5s;
    font-size: 150px;
  }
  a:not(:last-child) {
    margin-right: 10%;
  }
  @media (max-width: 768px) {
    a {
      font-size: 100px;
    }
    a:not(:last-child) {
      margin-right: 5%;
    }
  }
  a:hover {
    transform: scale(1.2);
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Intro/index.js